module.exports = "../fonts/ApercuLAPhil-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Regular.woff2
// module id = 505
// module chunks = 7